<template>
    <div class="h-4 rounded-lg bg-LeichtesGrau bg-opacity-30"></div>
</template>